export const STORE_STATUS = {
  initial: 'initial',
  idle: 'idle',
  loading: 'loading',
  fetching: 'fetching',
  error: 'error'
} as const
